import useAuthentication from "../Hooks/useAuthentication";
import { useAppSelector } from "../Store";
import { useAuthStore } from "../Store/Slices/AuthSlice";
import { isEmptyObject } from "../Utils";
import AuthRoutes from "./AuthRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import { AppConfig } from "../Config/app-config";
import { useEffect } from "react";
import { handleShopifyLoginUtil } from "../Utils/shopifyLogin";
import { useNotification } from "../Hooks/useNotification/useNotification";
const RootNavigator = () => {
  const { isUserLoggedIn } = useAuthentication();
  const { userConfig } = useAppSelector(useAuthStore);
  let { showAlert } = useNotification();
  const permissionsData: any = userConfig?.payload?.allowed_permissions ?? null;
  const data = AppConfig.getLoggedInData();
  const workspace_id = data?.data?.user?.workspace_id ?? "";
  const queryParams = new URLSearchParams(window.location.search);
  useEffect(() => {
    const shop = queryParams.get("shop")
    const code = queryParams.get("code")
    if(shop && code && workspace_id){
      handleShopifyLoginUtil(shop, code, workspace_id, showAlert,true);      
    }
}, []);
  if (
    isUserLoggedIn &&
    window.localStorage.getItem("expiry_time") &&
    userConfig?.payload &&
    isEmptyObject(permissionsData)
  )
    return null;
  return (
    <>
      {
        isUserLoggedIn ? ( <ProtectedRoutes />) : ( <AuthRoutes />)
      }
    </>
  );
};

export default RootNavigator;
